import { createFileRoute } from '@tanstack/react-router'

import { SimpleMessageScreen } from '@/components/system-screens'

const MaintenancePage = () => (
  <SimpleMessageScreen title="メンテナンス中です">作業が完了するまでしばらくお待ちください。</SimpleMessageScreen>
)

export const Route = createFileRoute('/maintenance')({ component: MaintenancePage })
